<template>
  <v-container>
    <v-row
      align="center"
    >
      <v-col
        cols="auto"
      >
        <div class="title text-uppercase font-weight-medium">
          Browse Blog Posts
        </div>
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-text-field
          v-model="filters.name"
          solo
          placeholder="Search"
          flat
          dense
          hide-details
          clearable
          append-icon="fas fa-search"
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          dark
          color="primary"
          class="ma-0"
          :to="{ name: 'new-blog-post' }"
        >
          <v-icon
            left
            small
          >
            fas fa-plus
          </v-icon>
          Add New
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <!--<editor-fold desc="Table">-->
      <v-col>
        <pagination
          :page.sync="items.pagination.page"
          :last-page="items.meta.last_page"
          :total="items.meta.total"
          :from="items.meta.from"
          :to="items.meta.to"
        />
        <v-data-table
          :headers="headers"
          :items="items.data"
          :server-items-length="items.meta.total"
          :sort-by.sync="items.sorting.sortBy"
          :sort-desc.sync="items.sorting.desc"
          :page.sync="items.pagination.page"
          :items-per-page="items.pagination.perPage"
          :loading="items.loading"
          hide-default-footer
          must-sort
          class="v-data-table--striped elevation-15"
          @update:sort-by="fetchItems()"
          @update:page="fetchItems()"
        >
          <template v-slot:item="{ item: blogPost }">
            <tr>
              <td>
                <router-link :to="{ name: 'blog-post', params: { id: blogPost.id }}">
                  <div class="subtitle-2 primary--text">
                    {{ blogPost.title }}
                  </div>
                  <div class="caption text--secondary">
                    {{ blogPost.excerpt }}
                  </div>
                </router-link>
              </td>
              <td style="width: 1px;">
                <router-link :to="{ name: 'blog-post', params: { id: blogPost.id }}">
                  <span
                    v-if="blogPost.updated_at"
                    class="text-no-wrap"
                  >{{ $dayjs(blogPost.updated_at).format('DD.MM.YYYY. HH:mm:ss') }}</span>
                  <span
                    v-else
                    class="grey--text text--lighten-1"
                  >
                    Never
                  </span>
                </router-link>
              </td>
              <td style="width: 1px">
                <router-link
                  :to="{ name: 'blog-post', params: { id: blogPost.id }}"
                  class="text-no-wrap"
                >
                  {{ $dayjs(blogPost.created_at).format('DD.MM.YYYY. HH:mm:ss') }}
                </router-link>
              </td>
              <td
                class="text-no-wrap"
                style="width: 1px"
              >
                <v-menu
                  offset-y
                  min-width="100px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      color="grey"
                      small
                      v-on="on"
                    >
                      <v-icon small>
                        fa fa-ellipsis-v
                      </v-icon>
                    </v-btn>
                  </template>
                  <!--                  <v-list-->
                  <!--                    dense-->
                  <!--                    class="body-2"-->
                  <!--                  >-->
                  <!--                    <v-list-item :to="{ name: 'radio', params: { id: radio.id }}">-->
                  <!--                      <v-list-item-icon>-->
                  <!--                        <v-icon small>-->
                  <!--                          fa fa-arrow-right-->
                  <!--                        </v-icon>-->
                  <!--                      </v-list-item-icon>-->
                  <!--                      <v-list-item-content>View Radio Details</v-list-item-content>-->
                  <!--                    </v-list-item>-->
                  <!--                    <v-list-item @click="editRadioDialog.radio = radio; editRadioDialog.visible = true">-->
                  <!--                      <v-list-item-icon>-->
                  <!--                        <v-icon small>-->
                  <!--                          fa fa-pen-->
                  <!--                        </v-icon>-->
                  <!--                      </v-list-item-icon>-->
                  <!--                      <v-list-item-content>Edit Radio</v-list-item-content>-->
                  <!--                    </v-list-item>-->
                  <!--                    <v-divider />-->
                  <!--                    <v-list-item @click="deleteDialog.radio = radio; deleteDialog.visible = true">-->
                  <!--                      <v-list-item-icon>-->
                  <!--                        <v-icon small>-->
                  <!--                          fa fa-trash-->
                  <!--                        </v-icon>-->
                  <!--                      </v-list-item-icon>-->
                  <!--                      <v-list-item-content>Delete Radio</v-list-item-content>-->
                  <!--                    </v-list-item>-->
                  <!--                  </v-list>-->
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="pa-2">
          <pagination
            :page.sync="items.pagination.page"
            :last-page="items.meta.last_page"
            :total="items.meta.total"
            :from="items.meta.from"
            :to="items.meta.to"
          />
        </div>
      </v-col>
    </v-row>

    <!--    <edit-radio-dialog-->
    <!--      :visible.sync="editRadioDialog.visible"-->
    <!--      :radio="editRadioDialog.radio"-->
    <!--      @radio:updated="fetchItems()"-->
    <!--      @radio:created="fetchItems()"-->
    <!--      @radio:deleted="fetchItems()"-->
    <!--    />-->

    <!--    <confirm-delete-dialog-->
    <!--      :visible.sync="deleteDialog.visible"-->
    <!--      :submitting="deleteDialog.deleting"-->
    <!--      @confirm="deleteRadio()"-->
    <!--    />-->
  </v-container>
</template>

<script>
import fetchableItemsMixin from '@/mixins/fetchableItemsMixin'
import Radios from '@/services/Radios'
import { cloneDeep } from 'lodash'
import RadioModel from '@/models/RadioModel'
import EditRadioDialog from '@/components/radio/EditRadioDialog'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'
import BlogPosts from '@/services/BlogPosts'

export default {
  name: 'Blog',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ConfirmDeleteDialog,
    // eslint-disable-next-line vue/no-unused-components
    EditRadioDialog
  },
  mixins: [fetchableItemsMixin],
  data() {
    return {
      editRadioDialog: {
        visible: false,
        radio: undefined
      },
      deleteDialog: {
        radio: undefined,
        visible: false,
        deleting: false
      }
    }
  },
  beforeCreate() {
    this.emptyFilters = cloneDeep(RadioModel.emptyFilters)
  },
  created() {
    this.headers = [
      { text: 'Title', value: 'title' },
      { text: 'Last Update', value: 'updated_at' },
      { text: 'Date Created', value: 'created_at' },
      { sortable: false }
    ]
  },
  methods: {
    async itemsFetcher(queryParams) {
      return await BlogPosts.fetch(queryParams)
    },
    async deleteRadio() {
      if (!this.deleteDialog.radio) return

      this.deleteDialog.deleting = true

      try {
        await Radios.delete(this.deleteDialog.radio.id)

        this.$store.dispatch('alert', {
          text: 'Successfully deleted',
          color: 'success'
        })

        this.fetchItems()
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'Something went wrong',
          color: 'error'
        })
        throw e
      } finally {
        this.deleteDialog.visible = false
        this.deleteDialog.deleting = false
      }
    }
  }
}
</script>
